// src/api.js
import axionIns from '../axios';

const BASE = process.env.REACT_APP_BACKEND_URL + 'api';

const getChats = () => axionIns.get(`${BASE}/chat/v2`).then(r => r.data);

export const createChat = (payload) =>
  axionIns.post(`${BASE}/chat/v2`, payload)
    .then(r => r.data?.data);

export const getMessages = chatId =>
  axionIns.get(`${BASE}/chat/v2/${chatId}/messages`).then(r => r.data?.data);

export const modifyChat = (chatId, changes) =>
  axionIns.patch(`${BASE}/chat/v2/${chatId}`, changes)
    .then(r => r.data?.data);

export const searchMessages = (q) =>
  axionIns.get(`${BASE}/chat/v2/search?q=${encodeURIComponent(q)}`)
    .then(r => r.data?.data);

const adminChat = (payload) => axionIns.post(`${BASE}/chat/v2/support`, payload).then(r => r?.data);

const getUnreadChat = () => axionIns.get(`${BASE}/chat/v2/unread`).then(r => r.data);


export default {
  getChats,
  adminChat,
  getUnreadChat
};
